import { useEffect, useState } from 'react'

const STORAGE_KEY = 'nav-collapsed'
const EVENT = 'nav-collapsed-change'

const isAutoCollapsedWidth = () =>
  typeof window !== 'undefined' && window.innerWidth >= 768 && window.innerWidth < 1280

const readCurrent = (): boolean => {
  if (typeof window === 'undefined') return false
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored !== null) return stored === 'true'
  return isAutoCollapsedWidth()
}

export const setNavCollapsed = (value: boolean) => {
  localStorage.setItem(STORAGE_KEY, String(value))
  window.dispatchEvent(new CustomEvent(EVENT))
}

export const useNavCollapsed = () => {
  const [collapsed, setCollapsed] = useState<boolean>(readCurrent)

  useEffect(() => {
    const sync = () => setCollapsed(readCurrent())
    window.addEventListener(EVENT, sync)
    window.addEventListener('storage', sync)
    window.addEventListener('resize', sync)
    return () => {
      window.removeEventListener(EVENT, sync)
      window.removeEventListener('storage', sync)
      window.removeEventListener('resize', sync)
    }
  }, [])

  return collapsed
}
